import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove SEO fallback from DOM on hydration to prevent duplicate content
const fallback = document.querySelector('.seo-fallback');
if (fallback) fallback.remove();

createRoot(document.getElementById("root")!).render(<App />);
